import { forwardRef, type Ref } from 'react';

// material-ui
import { Zoom } from '@mui/material';
import { alpha } from '@mui/material/styles';
import type { TransitionProps } from '@mui/material/transitions';
import { NonClosableBackdrop } from 'utils/modalBehavior';

// ==============================|| DIALOG ZOOM TRANSITION ||============================== //

const DialogTransition = forwardRef(function DialogTransition(
  props: TransitionProps & { children: React.ReactElement<unknown> },
  ref: Ref<unknown>
) {
  return (
    <Zoom
      ref={ref}
      {...props}
      timeout={{ appear: 280, enter: 280, exit: 200 }}
      easing={{ enter: 'cubic-bezier(0.0, 0, 0.2, 1)', exit: 'cubic-bezier(0.4, 0, 0.6, 1)' }}
      style={{ transformOrigin: 'center center', willChange: 'transform, opacity' }}
    />
  );
});

// ==============================|| OVERRIDES - DIALOG ||============================== //

export default function Dialog() {
  return {
    MuiDialog: {
      defaultProps: {
        disableEscapeKeyDown: true,
        slots: {
          backdrop: NonClosableBackdrop
        },
        TransitionComponent: DialogTransition,
        transitionDuration: { appear: 280, enter: 280, exit: 200 }
      },
      styleOverrides: {
        root: {
          '& .MuiBackdrop-root': {
            backgroundColor: alpha('#000', 0.5),
            transition: 'opacity 280ms cubic-bezier(0.0, 0, 0.2, 1) !important'
          }
        }
      }
    }
  };
}
